/* eslint-disable no-shadow */
import Cookies from 'js-cookie';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import api from '@api/index';

const state = {
  accessToken: null,
  user_info: null,
  role_code: null,
  policy_tos: '',
  policy_privacy: '',
  color_palette: [
    '#ff5583',
    '#fe7235',
    '#fec835',
    '#bbdc00',
    '#60bd05',
    '#25a4dc',
    '#0f71b7',
    '#b937e1',
  ],
  select: [
    {
      id: '0',
      name: '본사',
    },
    {
      id: '1',
      name: '목록 1',
    },
    {
      id: '2',
      name: '목록 2',
    },
    {
      id: '3',
      name: '목록 3',
    },
    {
      id: '4',
      name: '목록 4',
    },
    {
      id: '5',
      name: '목록 5',
    },
  ],
  foundEmailList: [],
  serviceSettings: {},
};

const getters = {
  fetchedPolicyTOS(state) {
    return state.policy_tos;
  },
  fetchedPolicyPrivacy(state) {
    return state.policy_privacy;
  },
  getServiceSettings(state) {
    return state.serviceSettings;
  },
  getFoundEmailList(state) {
    return state.foundEmailList;
  },
};

const mutations = {
  SET_POLICY_TOS(state, payload) {
    state.policy_tos = payload;
  },
  SET_POLICY_PRIVACY(state, payload) {
    state.policy_privacy = payload;
  },
  SET_FINDED_EMAIL(state, payload) {
    state.foundEmailList = payload;
  },
  SET_SERVICE_SETTINGS(state, payload) {
    state.serviceSettings = payload;
  },
};

const actions = {
  SIGNUP(_, userInfo) {
    return api.auth.fetchSignUp(userInfo).then(({ data }) => {
      if (data.code === Common.CODE_OK) {
        alert(eve.Lang.t('common.t_signup_mail'));
        eve.goPage('/login');
      }
    });
  },

  async fetchFoundEmail({ commit }, userInfo) {
    const response = await api.auth.findId(userInfo);
    commit('SET_FINDED_EMAIL', response.data.items);
    return response;
  },

  async FETCH_POLICY_TOS({ commit }) {
    // 이용약관
    let targetCode = '1F004';

    if (Cookies.get(Common.STORAGE_LANG) === 'ko') {
      targetCode = '1F003';
    }
    if (Cookies.get(Common.STORAGE_LANG) === 'ja') {
      targetCode = '1F002';
    }

    const response = await api.auth.fetchPolicy(targetCode, '1G002');
    commit('SET_POLICY_TOS', response.data.items.policy_contents);
    return response.data.items.policy_contents;
  },

  async FETCH_POLICY_PRIVACY({ commit }) {
    let targetCode = '1F004';

    if (Cookies.get(Common.STORAGE_LANG) === 'ko') {
      targetCode = '1F003';
    }
    if (Cookies.get(Common.STORAGE_LANG) === 'ja') {
      targetCode = '1F002';
    }

    // 개인정보 취급방침
    const response = await api.auth.fetchPolicy(targetCode, '1G001');
    commit('SET_POLICY_PRIVACY', response.data.items.policy_contents);
    return response.data.items.policy_contents;
  },

  async FETCH_SERVICE_SETTINGS({ commit }) {
    const response = await api.auth.getServiceSettings();
    commit('SET_SERVICE_SETTINGS', response.data.items);
    return response;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
